import { FieldWrapper } from 'DesignSystem';
import { useField } from 'formik';
import React, { FC } from 'react';
import { IBasePartnerCompany } from 'FeatureModules/Partner/types/partner.types';
import PartnerAutocomplete from 'FeatureModules/Partner/Components/Form/PartnerAutocomplete';

interface IPartnerAutocompleteProps {
  inviteNewPartner?: boolean;
  name: string;
  disabled?: boolean;
  label?: string;
  helperText?: string;
  isRequired?: boolean;
  labelVariant?: 'small' | 'medium';
  size?: 'small' | 'medium';
  'data-testid'?: string;
}

const PartnerAutocompleteWrapper: FC<IPartnerAutocompleteProps> = ({
  name,
  disabled,
  label,
  isRequired,
  helperText,
  labelVariant = 'small',
  size = 'small',
  'data-testid': dataTestId,
}) => {
  const [field, meta, helper] = useField<IBasePartnerCompany | undefined>(name);

  const handlePartnerSelect = async (partner: IBasePartnerCompany | null) => {
    await helper.setTouched(true);
    helper.setValue(partner || undefined, true);
  };

  return (
    <FieldWrapper
      label={label || 'Owner'}
      variant={labelVariant}
      required={isRequired}
      tooltip={
        helperText
          ? {
              helperText,
              variant: 'INFO',
            }
          : undefined
      }
    >
      <PartnerAutocomplete
        defaultValue={field.value}
        size={size}
        disabled={disabled}
        errorMessage={meta.error}
        hasError={!!meta.error && meta.touched}
        filterByRegisteredPartners={false}
        onPartnerSelect={handlePartnerSelect}
        data-testid={dataTestId}
      />
    </FieldWrapper>
  );
};

export default PartnerAutocompleteWrapper;
